import React, { Component } from 'react';
import './App.css';
import 'babel-polyfill';
// import NormalLoginForm from './Login.js';
import { Layout, Menu, Icon, Input, Button, Checkbox, Spin } from 'antd';
import { HashRouter, Route, NavLink } from 'react-router-dom';
import { db } from './fire';
import Loadable from 'react-loadable';

const LoadableDashboard = Loadable({
  loader: () => import('./Dashboard'),
  loading: () => <div style={{textAlign: "center"}}><Spin /></div>
});
const LoadableOrders = Loadable({
  loader: () => import('./Orders'),
  loading: () => <div style={{textAlign: "center"}}><Spin /></div>
});
const LoadableCreate = Loadable({
  loader: () => import('./Create'),
  loading: () => <div style={{textAlign: "center"}}><Spin /></div>
});

const { Header, Sider, Content } = Layout;

const FullMenu = (props) => (
  <div>
    <div className={`logo ${props.logo}`}>
    </div>
    <div className="textLogo">SCA</div>
    <Menu {...props} defaultSelectedKeys={[window.location.hash.split('#')[1] || '/']}>
    <Menu.Item key="/">
        <NavLink to='/'>
          <Icon type="plus" />
          <span className='menuText'>Submit Orders</span>
        </NavLink>
      </Menu.Item>
      <Menu.Item key="/orders">
        <NavLink to="/orders">
          <Icon type="shopping-cart" />
          <span className='menuText'>Report</span>
        </NavLink>
      </Menu.Item>
      {/* <Menu.Item key="/login">
        <NavLink to='/login'>
          <Icon type="user" />
          <span>Login</span>
        </NavLink>
      </Menu.Item> */}
      <Menu.Item key="/dashboard">
        <NavLink to='/dashboard'>
          <Icon type="dashboard" />
          <span className='menuText'>Dashboard</span>
        </NavLink>
      </Menu.Item>
    </Menu>
  </div>
);

class LogIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: this.props.title,
      password: "",
      loading: false,
      type: "password"
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  handleChange(e) {
    this.setState({
      password: e.target.value
    });
  }

  handleClick(e) {
    e.preventDefault();
    this.setState({ loading: true });
    let { password } = this.state;
    if (password === "") {
      this.setState({loading: false, title: "Password should not be blank!"});
    } else {
      db.collection('pwd').get()
      .then((d) => {
        let pwd = "";
        d.forEach((da) => {pwd = da.data().password});
        if (pwd === password) {
          this.props.logIn();
        }
        else {
          this.setState({ title: "Password is incorrect" });
        }
      })
      .catch((e) => {
        console.log(e)
        this.setState({loading: false});
      });
    }
  }

  onChange() {
    let { type } = this.state;
    type = type === 'password' ? 'text' : 'password';
    this.setState({ type });
  }

  render() {
    const { title, loading, type } = this.state;

    return (
      <div>
        <p className="title">{title}</p>
        <Input placeholder="Password" type={type} style={{width: 300, margin: "10px auto", display: "block"}} onBlur={this.handleChange} />
        <Checkbox onChange={this.onChange} style={{margin: "20px auto", textAlign: "center", display: "block"}}>Show Password</Checkbox>
        <Button loading={loading} style={{margin: "0 auto", display: "block"}} type="primary" onClick={this.handleClick}>Log-in</Button>
      </div>
    );
  }
}
  

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      collapsed: false,
      width: window.innerWidth, 
      height: window.innerHeight,
      loggedIn: false
    };
    // this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    // this.updateWindowDimensions();
    this.logIn = this.logIn.bind(this);
  }

  logIn() {
    this.setState({ loggedIn: true });
  }

  // componentDidMount() {
  //   this.updateWindowDimensions();
  //   window.addEventListener('resize', this.updateWindowDimensions);
  // }
  
  // componentWillUnmount() {
  //   window.removeEventListener('resize', this.updateWindowDimensions);
  // }
  
  // updateWindowDimensions() {
  //   this.setState({ width: window.innerWidth, height: window.innerHeight });
  // }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  render() {
    const { width, loggedIn } = this.state;

    return (
      <HashRouter>
        <Layout>
          {width > 1200 ? 
            <Sider
              trigger={null}
              collapsible
              collapsed={this.state.collapsed}
              theme="light"
            >
              <FullMenu mode="inline" theme="light" style={{}} logo="ver" />
            </Sider>
          :
            <Header className="hor" theme="light">
              <FullMenu mode="horizontal" theme="light" style={{ lineHeight: '64px' }} logo="hor" />
            </Header>
          }
          
          <Layout>
            {width > 1200 ? 
            <Header style={{ background: 'rgb(21, 41, 79)', padding: 0 }}>
              <Icon
                className="trigger"
                type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                onClick={this.toggle}
              />
            </Header>
            : null
            }
            <Content style={{ margin: '24px 16px', padding: 24, background: '#fff', minHeight: 280 }}>
              { loggedIn ? (
                <div>
                <Route exact path="/dashboard" component={LoadableDashboard} />
                <Route exact path="/orders" component={LoadableOrders} />
                </div>
              ) : <Route path="/:d" component={() => <LogIn logIn={this.logIn} title="You need to be logged in to do that"/>} /> 
              }
              <Route exact path="/" component={LoadableCreate} />
              

            </Content>
          </Layout>
        </Layout>
      </HashRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js